// extracted by mini-css-extract-plugin
export var typingIndicator = "_rk-0";